import "../styles/main.css";

import principal from "../assets/principal.jpg";
import secretary from "../assets/secretary.jpg";
import founder from "../assets/founder.jpg";
import chairman from "../assets/chairman.jpg";

function About({ mode }) {

  return (
    <div className={`about ${mode === "school" ? "school-about" : "college-about"}`}>

      <h2>{mode === "school" ? "About Our School" : "About Our Institution"}</h2>

      {/* COLLEGE  */}
    
{mode === "college" && (
  <>

    {/* INTRO */}
    <section>
      <h3> Introduction</h3>
      <p>
        <strong>TEJKIRTI SENIOR WOMEN’S COLLEGE</strong> is a dedicated institution committed to empowering women through quality education and holistic development. 
        Affiliated to S.N.D.T. Women’s University, Mumbai, and managed by Adarsh Shikshan Prasarak Mandal, the college strives to create an environment where young women can grow academically, socially, and personally. 
        Since its establishment, the college has focused on providing not only academic knowledge but also strong moral values, confidence, and leadership qualities.
         We believe that education is the key to transforming lives, and we aim to shape our students into independent, responsible, and capable individuals who can contribute positively to society.
          Our campus provides a safe, inclusive, and motivating atmosphere where students are encouraged to explore their talents, participate in activities, and achieve their full potential.
      </p>

      <p>
        Since its establishment, the college focuses on academic excellence, moral values, confidence, and leadership qualities.
      </p>

      <p>
        Our campus provides a safe, inclusive, and motivating environment where students grow and achieve their full potential.
      </p>
    </section>

    {/* VISION */}
    <section>
      <h3> Vision</h3>
      <p>
       Vision To be a leading institution in women’s education that nurtures knowledge, confidence, and values, enabling students to become empowered individuals and responsible citizens of the nation.      </p>
    </section>

    {/* MISSION */}
    <section>
      <h3> Mission</h3>
      <ul className="mission-list">
        <li>Provide high-quality education</li>
        <li>Promote holistic development</li>
        <li>Encourage leadership & confidence</li>
        <li>Create safe learning environment</li>
        <li>Prepare students for future careers</li>
      </ul>
    </section>

    {/*LEADERS (SCROLL DESIGN)*/}

    {/* SECRETARY */}
    <div className="leader-row">
      <div className="leader-img">
        <img src={secretary} alt="Secretary" />
      </div>
      <div className="leader-text">
        <h3>Secretary – Dhamchari T. S. Jadhav</h3>
        <p>
          Our goal is to provide quality education that empowers women to become confident, self-reliant, and successful in every field of life. We are committed to creating opportunities that help students grow and achieve their dreams.        </p>
      </div>
    </div>

    {/* FOUNDER */}
    <div className="leader-row reverse">
      <div className="leader-img">
        <img src={founder} alt="Founder" />
      </div>
      <div className="leader-text">
        <h3>Founder Secretary – Rajendra Jadhav</h3>
        <p>
        Education is the foundation of a strong society. Our institution focuses on building knowledge, values, and discipline in students so that they can contribute positively to the nation.        </p>
      </div>
    </div>

    {/* CHAIRMAN */}
    <div className="leader-row">
      <div className="leader-img">
        <img src={chairman} alt="Chairman" />
      </div>
      <div className="leader-text">
        <h3>Founder Chairman – Aniket Jadhav</h3>
        <p>
          We believe in nurturing young minds with the right guidance, skills, and opportunities. Our aim is to develop future leaders who are capable, responsible, and innovative.        </p>
      </div>
    </div>

    {/* PRINCIPAL */}
    <div className="leader-row reverse">
      <div className="leader-img">
        <img src={principal} alt="Principal" />
      </div>
      <div className="leader-text">
        <h3>Principal – Mrs. Varsha M. Bagul</h3>
        <p>
         At our college, we focus on academic excellence along with overall personality development. We ensure that students are prepared not only for exams but also for real-life challenges, with confidence and strong values.        </p>
      </div>
    </div>

    {/* UNIVERSITY */}
    <section>
      <h3>5. About University</h3>
      <p>
      S.N.D.T. Women’s University, Mumbai is one of the premier institutions in India dedicated to women’s education. It offers a wide range of academic programs and focuses on empowering women through knowledge, research, and skill development. The university is known for its commitment to excellence and its role in promoting higher education for women across the country.      </p>
    </section>

  </>
)}

      {/*  SCHOOL */}
      {mode === "school" && (
        <section className="school-about-content">
          <h3>About Pre-School</h3>

          <p>
            Tejkirti Little Star Pre-School is a joyful and nurturing learning space where young minds begin their journey.
          </p>

          <p>
            We provide a safe and engaging environment for emotional, social, and intellectual development.
          </p>

          <p>
            Our teaching includes fun-based learning, creativity, and communication skills.
          </p>

          <p>
            We inspire children to explore, learn, and shine bright like stars 🌟
          </p>
        </section>
      )}

    </div>
  );
}

export default About;